import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@fast-ai/ui-components';
import { useIntl } from 'gatsby-theme-fast-ai-sidebar';

const format = ({ formatDate, formatTime, disableTime, value }) =>
	[
		formatDate(value, {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
		}),
		!disableTime
			? formatTime(value, {
				hour12: false,
				second: 'numeric',
				minute: 'numeric',
				hour: 'numeric',
			})
			: null,
	]
		.filter(Boolean)
		.join(' ');

const DateTime = forwardRef(
	({ comp: Comp = Box, sx, children, disableTime, ...rest }, ref) => {
		const { formatDate, formatTime } = useIntl();

		const formatted = useMemo(
			() => format({ formatDate, disableTime, formatTime, value: children }),
			[children, disableTime, formatTime, formatDate]
		);

		return (
			<Comp
				dateTime={children?.toISOString()}
				ref={ref}
				sx={{ whiteSpace: 'nowrap', ...sx }}
				{...rest}
				as="time"
			>
				{formatted}
			</Comp>
		);
	}
);

DateTime.propTypes = {
	children: PropTypes.instanceOf(Date),
	comp: PropTypes.elementType,
	disableTime: PropTypes.bool,
};

DateTime.displayName = 'DateTime';

export default DateTime;
